import React, {useEffect, useState} from "react";
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';

const GroupCard = (props) => {
    const {
        isMobile,
        group,
        onUpdateGroupPositions,
        myGroupPositions
    } = props;

    // console.log("myGroupPositions here in card >>>", myGroupPositions);

    // console.log("group >>>>", group)

    const getInitialSelectedTeams = () => {
        const groupPosition = myGroupPositions?.find(pos => pos?.name === group?.group);
        return {
            first_position: groupPosition?.first_position_team?.goalserve_id || "",
            last_position: groupPosition?.last_position_team?.goalserve_id || ""
        };
    };

    // const [selectedTeams, setSelectedTeams] = useState({ first_position: "", last_position: "" });
    const [selectedTeams, setSelectedTeams] = useState(getInitialSelectedTeams);

    const [smallMobileScreens, setSmallMobileScreens] = useState(false);

    // console.log("selectedTeams >>>", selectedTeams)
    // console.log("smallMobileScreens >>>", smallMobileScreens)
    // console.log("window.screen.width >>>", window.screen.width)

    useEffect(() => {
        if (window.screen.width <= 423) {
            // setIsMobile(true);
            // console.log("adjust")
            setSmallMobileScreens(true)
        } else {
            // setIsMobile(false);
        }
    }, [window.screen.width, isMobile]);

    const updateGroupPositions = () => {
        const groupName = group.group; // Assuming group.group contains the group name
        const updatedPositions = {
            first_position: selectedTeams?.first_position || "",
            last_position: selectedTeams?.last_position || ""
        };
        onUpdateGroupPositions(groupName, updatedPositions);
    };

    useEffect(() => {
        updateGroupPositions();
    }, [selectedTeams]);

    const handleTeamClick = (teamId) => {
        let newSelectedTeams = { ...selectedTeams };

        // If the clicked team is already the first selected team, deselect it
        if (selectedTeams?.first_position === teamId) {
            newSelectedTeams = { ...selectedTeams, first_position: "" };
        } else {
            // If the clicked team is already the last selected team, deselect it
            if (selectedTeams?.last_position === teamId) {
                newSelectedTeams = { ...selectedTeams, last_position: "" };
            }

            // If there's no first selected team, make the clicked team the first selected team
            if (!selectedTeams?.first_position) {
                newSelectedTeams = { ...selectedTeams, first_position: teamId };
            } else {
                // If there's no last selected team, make the clicked team the last selected team
                if (!selectedTeams?.last_position) {
                    newSelectedTeams = { ...selectedTeams, last_position: teamId };
                }
            }
        }
        setSelectedTeams(newSelectedTeams);
    };

    const isFirstSelected = (teamId) => selectedTeams?.first_position === teamId;
    const isLastSelected = (teamId) => selectedTeams?.last_position === teamId;

    const groupBackgroundColors = {
        "Group A": "bg-group-a",
        "Group B": "bg-group-b",
        "Group C": "bg-group-c",
        "Group D": "bg-group-d",
        "Group E": "bg-group-e",
        "Group F": "bg-group-f"
    };


    const renderMobile = () => {
        return (
            <>
                <Card
                    style={{minWidth: smallMobileScreens ? "20rem":'12rem'}}
                >
                    <Card.Header
                        className={`text-center text-uppercase fw-400 font-15 text-white p-1 ${
                            groupBackgroundColors[group?.group] || "bg-skins-red"
                        }`}
                    >
                        {group?.group}
                    </Card.Header>
                    <ListGroup variant="flush">
                        {group?.teams?.map((team, index) => (
                            <ListGroup.Item
                                key={index}
                                className={`d-flex align-items-center gap-2 p-1`}
                            >
                                <div
                                    role={"button"}
                                    className={`w-100 d-flex align-items-center gap-2 p-2 ${
                                        isFirstSelected(team?.goalserve_id) ? "border-first-place" :
                                            isLastSelected(team?.goalserve_id) ? "border-last-place" : "border-white"
                                    }`}
                                    onClick={() => handleTeamClick(team?.goalserve_id)}
                                >
                                    {/*<div className={"rounded rounded-circle border"}>*/}
                                        <img
                                            src={team?.icon}
                                            className="avatar"
                                            alt={team?.alt_name || "..."}/>
                                    {/*</div>*/}
                                    <div className={"fw-500 font-16"}>
                                        {team?.name}
                                    </div>
                                </div>

                            </ListGroup.Item>
                        ))}

                    </ListGroup>
                </Card>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <Card style={{width: '12.5rem'}}>
                    <Card.Header
                        className={`text-center text-uppercase fw-400 font-15 text-white p-1 ${
                            groupBackgroundColors[group?.group] || "bg-skins-red"
                        }`}
                    >
                        {group?.group}
                    </Card.Header>
                    <ListGroup variant="flush">
                        {group?.teams?.map((team, index) => (
                            <ListGroup.Item
                                key={index}
                                className={`d-flex align-items-center gap-2 p-1`}
                            >
                                <div
                                    role={"button"}
                                    className={`w-100 d-flex align-items-center gap-2 p-2 ${
                                        isFirstSelected(team?.goalserve_id) ? "border-first-place" :
                                            isLastSelected(team?.goalserve_id) ? "border-last-place" : "border-white"
                                    }`}
                                    onClick={() => handleTeamClick(team?.goalserve_id)}
                                >
                                    {/*<div className={"rounded rounded-circle border"}>*/}
                                        <img
                                            src={team?.icon}
                                            className="avatar"
                                            alt={team?.alt_name || "..."}/>
                                    {/*</div>*/}
                                    <div className={"fw-500 font-16"}>
                                        {team?.name}
                                    </div>
                                </div>

                            </ListGroup.Item>
                        ))}

                    </ListGroup>
                </Card>
            </>
        );
    }
    const render = () => {
        return (
            <section
            >
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default GroupCard;
